import OfferCard from '../../Molecules/OfferCard/OfferCard';
const CheckoutOfferSection = (props: { offer: any[] }): JSX.Element => {
    return (
        <ul className='psc-cart-checkout'>
            <OfferCard offer={props.offer[0].offer} isOfferInCart={true} isCheckout={true} />
        </ul>
    );
}
export default CheckoutOfferSection;